import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Badge, Flex, Text, getPaletteColor } from 'pcln-design-system';
import useCountdown from '../utils/useCountdown';
const BorderText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Badges__BorderText",
  componentId: "sc-8uxb0g-0"
})(["border-radius:", ";border:1px solid ", ";width:inherit;"], themeGet('borderRadii.sm'), getPaletteColor('background.lightest'));
const CardBadge = /*#__PURE__*/styled(Badge).withConfig({
  displayName: "Badges__CardBadge",
  componentId: "sc-8uxb0g-1"
})(["white-space:nowrap;"]);
const Badges = ({
  badgeColor,
  badgeText,
  borderText,
  pb,
  targetDate,
  textColor,
  timerCopy
}) => {
  const remainingTime = useCountdown({
    targetDate,
    timerCopy
  });
  if (!badgeText && !borderText && !targetDate) {
    return null;
  }
  let topFlexJustify = ['space-between'];
  if (!badgeText && borderText) {
    topFlexJustify = ['flex-end', null, 'flex-start', null, 'flex-end'];
  } else if (badgeText && !borderText) {
    topFlexJustify = ['flex-start'];
  }
  const badgeProps = badgeColor ? {
    color: badgeColor
  } : {
    bg: 'highlight.light',
    color: 'success.dark'
  };
  return React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: topFlexJustify,
    pb: pb || [2, null, null, null, 3],
    mb: 1
  }, (badgeText || targetDate) && React.createElement(CardBadge, {
    ...badgeProps,
    size: 'small',
    mr: 2
  }, targetDate ? remainingTime : badgeText), borderText && React.createElement(BorderText, {
    color: textColor,
    px: 1,
    py: '3px',
    textAlign: 'center',
    textStyle: 'label'
  }, borderText));
};
export default Badges;